import InCallManager from "react-native-incall-manager";
import React from "react";

import {
  Alert,
  AppState,
  Image,
  Text,
  TouchableOpacity,
  View
} from "react-native";
import { Voximplant } from "react-native-voximplant";
import { connect } from "react-redux";

import PulseLoader from "../components/PulseLoader";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

import {
  getBaseUrl,
  getVoximplantAccountName,
  getVoximplantAppName
} from "../helpers/storage";

class AudioCallScreen extends React.Component {
  constructor(props) {
    super(props);

    const { doctor, patient, transaction } = this.props.navigation.state.params;

    this.state = {
      doctor: {
        avatarUrl: null,
        fullName: doctor.fullName
      },
      isLoading: true,
      patient: {
        id: patient.id
      },
      transaction: {
        id: transaction.id
      }
    };
  }

  componentDidMount() {
    AppState.addEventListener("change", this.handleAppStateChange);

    InCallManager.start({ media: "audio", ringback: "_BUNDLE_" });

    this.client = Voximplant.getInstance();

    this.connect().then(() => this.login());
  }

  componentWillUnmount() {
    AppState.removeEventListener("change", this.handleAppStateChange);

    this.client.disconnect();

    InCallManager.stop({ busytone: "_BUNDLE_" });
  }

  handleAppStateChange = appState => {
    if (appState === "background") {
      if (this.client) {
        this.client.disconnect();
      }
    }
  };

  async connect() {
    await this.client.connect();
  }

  async exchangeLoginKey(key) {
    const { token } = this.props;

    const baseUrl = getBaseUrl();

    const response = await fetch(baseUrl + "call/start", {
      body: JSON.stringify({
        login_key: key
      }),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json"
      },
      method: "POST"
    });

    const json = await response.json();

    return {
      doctor: {
        alias: json["data"]["doctor"]["alias"],
        avatarUrl: json["data"]["doctor"]["avatar_url"]
      },
      token: json["data"]["token"]
    };
  }

  async login() {
    const { doctor: oldDoctor, patient, transaction } = this.state;

    const accountName = getVoximplantAccountName();
    const appName = getVoximplantAppName();

    const domain = appName + "." + accountName + ".voximplant.com";

    const alias = "patient-" + patient.id;

    try {
      await this.client.requestOneTimeLoginKey(alias + "@" + domain);
    } catch (e) {
      if (e.code === 302) {
        const { doctor: newDoctor, token } = await this.exchangeLoginKey(e.key);

        await this.client.loginWithOneTimeKey(alias + "@" + domain, token);

        const call = await this.client.call(newDoctor.alias + "@" + domain, {
          customData: JSON.stringify({
            transaction_id: transaction.id
          })
        });
        call.on(Voximplant.CallEvents.Connected, () => {
          InCallManager.stopRingback();

          this.setState({
            doctor: {
              avatarUrl: newDoctor.avatarUrl,
              fullName: oldDoctor.fullName
            },
            isLoading: false
          });
        });
        call.on(Voximplant.CallEvents.Disconnected, () =>
          this.props.navigation.goBack()
        );
        call.on(Voximplant.CallEvents.Failed, e => {
          if (e.code === 603) {
            Alert.alert(
              "Whoops",
              "Mohon maaf untuk sementara dokter tidak dapat menerima panggilan karena trafik yang tinggi."
            );
          }

          this.props.navigation.goBack();
        });
      }
    }
  }

  renderContent = () => {
    const { doctor } = this.state;

    return <Image source={{ uri: doctor.avatarUrl }} style={{ flex: 1 }} />;
  };

  renderLoading = () => <PulseLoader />;

  render() {
    const { themeColors } = this.props;
    const { doctor, isLoading } = this.state;

    let container;

    if (isLoading) {
      container = this.renderLoading();
    } else {
      container = this.renderContent();
    }

    return (
      <View style={{ backgroundColor: themeColors.primary, flex: 1 }}>
        <View style={{ flex: 1, justifyContent: "space-around" }}>
          <View
            style={{ alignItems: "center", alignSelf: "center", padding: 20 }}
          >
            <Text
              style={{
                color: staticColors.white,
                fontSize: 24,

                ...fonts.regular
              }}
            >
              Panggilan Suara
            </Text>
            <Text
              style={{ color: staticColors.white, fontSize: 24, ...fonts.bold }}
            >
              {doctor.fullName}
            </Text>
          </View>

          {container}
        </View>
        <View
          style={{
            backgroundColor: staticColors.white,
            borderTopEndRadius: 40,
            borderTopStartRadius: 40,
            marginTop: -40,
            padding: 25
          }}
        >
          <TouchableOpacity
            onPress={() => this.props.navigation.goBack()}
            style={{ alignItems: "center" }}
          >
            <View
              style={{
                alignItems: "center",
                backgroundColor: staticColors.thimbleberry,
                borderRadius: 25,
                height: 50,
                justifyContent: "center",
                width: 50
              }}
            >
              <Image
                source={require("../assets/icons/round_call_end_white_36dp.png")}
                style={{ height: 30, width: 30 }}
              />
            </View>
            <Text
              style={{
                color: staticColors.cavernous,
                fontSize: 18,
                marginTop: 10,

                ...fonts.regular
              }}
            >
              Akhiri Panggilan
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(AudioCallScreen);
